module.exports = __webpack_public_path__ + "static/img/dentaltalk_sm_portrait.237e9fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/dentaltalk_sm_portrait.png
// module id = iZ6Q
// module chunks = 1